import {Action, ActionReducerMap} from '@ngrx/store';

import * as actionsUi from './veranstaltungen-info-kategorien.actions.ui';

import {
    InfoKategorie
} from '../../../../clients/veranstaltungen';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN, GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN_ERFOLGREICH, GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN_FEHLER, GetVeranstaltungInfoKategorieAdminAction, GetVeranstaltungInfoKategorienAdminErfolgreichAction} from '../../../../client-ngrx/veranstaltungen';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    aktuelleVeranstaltungsId: string;
    infoKategorien: Array<InfoKategorie>;
    infoKategorienLaden: boolean;
    infoKategorienFehler: boolean;
}

export const initialPageState: PageState = {
    aktuelleVeranstaltungsId: null,
    infoKategorien: [],
    infoKategorienLaden: false,
    infoKategorienFehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState, {
            });
        }

        // Veranstaltung Info Kategorien
        case GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN: {
            const a = <GetVeranstaltungInfoKategorieAdminAction>action;
            return Object.assign({}, state, <PageState>{
                aktuelleVeranstaltungsId: a.veranstaltung_id,
                infoKategorienLaden: true,
                infoKategorienFehler: false
            });
        }

        case GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN_ERFOLGREICH: {
            const a = <GetVeranstaltungInfoKategorienAdminErfolgreichAction>action;
            return Object.assign({}, state, <PageState>{
                infoKategorien: a.payload,
                infoKategorienLaden: false,
                infoKategorienFehler: false
            });
        }

        case GET_VERANSTALTUNG_INFO_KATEGORIEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                infoKategorien: [],
                infoKategorienLaden: false,
                infoKategorienFehler: true
            });
        }

        default: {
            return state;
        }
    }
}

